export const selectGoodsColumns = [
  {
    title: "货品名称",
    dataIndex: "goodsName",
    width: "22%",
    key: "goodsName"
  },
  {
    title: "货品编号",
    dataIndex: "goodsNo",
    width: "20%",
    key: "goodsNo"
  },
  {
    title: "货品规格",
    width: "10%",
    dataIndex: "goodsSpecification",
    key: "goodsSpecification"
  },
  {
    title: "货品总重",
    width: "12%",
    // dataIndex: "goodsWeight",
    key: "goodsWeight",
    scopedSlots: { customRender: "goodsWeight" }
  },
  {
    title: "货品总件数",
    // dataIndex: "goodsNum",
    width: "12%",
    key: "goodsNum",
    scopedSlots: { customRender: "goodsNum" }
  },
  {
    title: "备注",
    // dataIndex: "goodsNote",
    key: "goodsNote",
    scopedSlots: { customRender: "goodsNote" }
  }
]

export const selectOrderColumns = [
  {
    title: "单号",
    dataIndex: "orderNo",
    width: 72,
    align: "center",
    key: "orderNo"
  },
  {
    title: "收货单位",
    dataIndex: "receiveName",
    width: 96,
    align: "center",
    ellipsis: true,
    key: "receiveName"
  },
  {
    title: "发货单位",
    width: 96,
    align: "center",
    ellipsis: true,
    dataIndex: "originName",
    key: "originName"
  },
  {
    title: "货品",
    width: 80,
    align: "center",
    dataIndex: "goodsName",
    key: "goodsName",
    ellipsis: true
  },
  {
    title: "编号",
    dataIndex: "goodsNo",
    width: 56,
    align: "center",
    key: "goodsNo",
    ellipsis: true
  },
  {
    title: "余量",
    dataIndex: "goodsMargin",
    width: 40,
    align: "center",
    key: "goodsMargin",
    ellipsis: true
  },
  {
    title: "规格",
    dataIndex: "goodsSpecification",
    width: 40,
    align: "center",
    key: "goodsSpecification",
    ellipsis: true
  },
  {
    title: "件数",
    dataIndex: "goodsNum",
    width: 40,
    align: "center",
    key: "goodsNum",
    ellipsis: true
  },
  {
    title: "备注",
    dataIndex: "goodsNote",
    width: 64,
    align: "center",
    key: "goodsNote",
    ellipsis: true
  },
  {
    title: "装车量",
    // dataIndex: "goodsLoadQuantity",
    width: 120,
    align: "center",
    key: "goodsLoadQuantity",
    fixed: "right",
    scopedSlots: { customRender: "goodsLoadQuantity" }
  }

  // {
  //   title: "备注",
  //   // dataIndex: "goodsNote",
  //   key: "goodsNote",
  //   scopedSlots: { customRender: "goodsNote" }
  // }
]

export const selectVehicleColumns = [
  {
    title: "车牌号",
    dataIndex: "vehicleNumber",
    width: 72,
    align: "center",
    key: "vehicleNumber"
  },
  {
    title: "司机姓名",
    dataIndex: "driverName",
    width: 72,
    align: "center",
    ellipsis: true,
    key: "driverName"
  },
  {
    title: "司机手机号",
    width: 96,
    align: "center",
    ellipsis: true,
    dataIndex: "tel",
    key: "tel"
  },
  {
    title: "限重",
    width: 80,
    align: "center",
    dataIndex: "limitTotalLoad",
    key: "limitTotalLoad",
    ellipsis: true
  },
  {
    title: "车身长",
    dataIndex: "length",
    width: 56,
    align: "center",
    key: "length",
    ellipsis: true
  }
]

export const selectTruckOrdersColumns = [
  {
    title: "派车单号",
    dataIndex: "truckOrderNo",
    width: "25%",
    align: "center",
    key: "truckOrderNo"
  },
  {
    title: "订单编号",
    dataIndex: "orderNo",
    width: "25%",
    align: "center",
    key: "orderNo"
  },
  {
    title: "司机名",
    width: "15%",
    align: "center",
    dataIndex: "driverName",
    key: "driverName"
  },
  {
    title: "司机电话",
    width: "20%",
    align: "center",
    dataIndex: "driverTel",
    key: "driverTel"
  },
  {
    title: "车牌号",
    width: "15%",
    align: "center",
    key: "vehicleNumber",
    dataIndex: "vehicleNumber"
  },
  {
    title: "收货地址",
    dataIndex: "receiveName",
    width: "30%",
    align: "center",
    key: "receiveName"
  },
  {
    title: "收货电话",
    align: "center",
    width: "15%",
    dataIndex: "receiveTel",
    key: "receiveTel"
  },
  {
    title: "发货地址",
    align: "center",
    width: "30%",
    dataIndex: "originName",
    key: "originName"
  },
  {
    title: "发货电话",
    align: "center",
    width: "15%",
    dataIndex: "originTel",
    key: "originTel"
  },
  {
    title: "货品名称",
    dataIndex: "goodsName",
    width: "30%",
    align: "center",
    key: "goodsName"
  },
  {
    title: "货品编号",
    dataIndex: "goodsNo",
    width: "20%",
    align: "center",
    key: "goodsNo"
  },
  {
    title: "货品规格",
    width: "11%",
    align: "center",
    dataIndex: "goodsSpecification",
    key: "goodsSpecification"
  },
  {
    title: "货品重量",
    width: "11%",
    align: "center",
    key: "goodsWeight",
    dataIndex: "goodsWeight"
  },
  {
    title: "货品件数",
    dataIndex: "goodsNum",
    width: "11%",
    align: "center",
    key: "goodsNum"
  },
  {
    title: "装车重量",
    width: "11%",
    align: "center",
    key: "goodsLoadQuantity",
    dataIndex: "goodsLoadQuantity"
  }
]

export const selectTruckOrderGoodsColumns = [
  {
    title: "货品名称",
    dataIndex: "goodsName",
    width: "22%",
    align: "center",
    key: "goodsName"
  },
  {
    title: "货品编号",
    dataIndex: "goodsNo",
    width: "20%",
    align: "center",
    key: "goodsNo"
  },
  {
    title: "货品规格",
    width: "10%",
    align: "center",
    dataIndex: "goodsSpecification",
    key: "goodsSpecification"
  },
  {
    title: "装车重量",
    width: "12%",
    align: "center",
    key: "goodsLoadQuantity",
    dataIndex: "goodsLoadQuantity"
  },
  {
    title: "货品总件数",
    dataIndex: "goodsNum",
    width: "12%",
    align: "center",
    key: "goodsNum"
  },
  {
    title: "备注",
    align: "center",
    dataIndex: "goodsNote",
    key: "goodsNote"
  }
]
